var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogohome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 150 150",
    id: "ART",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}.cls-2{fill:#fcd700;stroke:#000000;stroke-miterlimit:10;stroke-width:4px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.43,36.74c10.1-10.28,24.86-15,27-9.54s-6.51,7.86-19,22.36S34.48,72.9,29.33,72.24,26.39,49,38.43,36.74Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.43,36.74c10.1-10.28,24.86-15,27-9.54s-6.51,7.86-19,22.36S34.48,72.9,29.33,72.24,26.39,49,38.43,36.74Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.7,75.61c0,31.18-18.48,56.93-46.3,60.84-2.4.34-7.72,8.9-10.35,8.9s-8-8.57-10.37-8.9C36.81,132.54,18.3,106.79,18.3,75.61,18.3,46.43,32.15,24,57.42,17.78c4.06-1,3.8-13.13,17.64-13.13S88.62,16.78,92.67,17.78C117.89,24,131.7,46.43,131.7,75.61Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.43,36.74c10.1-10.28,24.86-15,27-9.54s-6.51,7.86-19,22.36S34.48,72.9,29.33,72.24,26.39,49,38.43,36.74Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.43,36.74c10.1-10.28,24.86-15,27-9.54s-6.51,7.86-19,22.36S34.48,72.9,29.33,72.24,26.39,49,38.43,36.74Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogohome);
export default __webpack_public_path__ + "static/media/logohome.5304e6c48cd3a423423154bd74d885f7.svg";
export { ForwardRef as ReactComponent };